import { Injectable } from '@angular/core';
import { timeout, catchError } from 'rxjs/operators';
import { getEndpoint } from 'src/app/core/services/functions.service';
import { RequestsService } from 'src/app/core/services/requests.service';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LogisticaService {
  company = 'JA';
  url_liberar = `${getEndpoint('liberarCita_seus')}`;

  url_crear_poligono = `${getEndpoint('crear_poligonos')}`;

  url_get_departamento = `${getEndpoint('get_departamento')}`;

  url_get_municipio = `${getEndpoint('get_municipio')}`;
 
  url_zonas = `${getEndpoint('get_zona')}`;

  url_poligonos = `${getEndpoint('obtener_polígono')}`;

  url_crear_geografia = `${getEndpoint('crear_geografia')}`;

  url_crear_capacidades = `${getEndpoint('crear_capacidades')}`;

  url_crear_capacidades_por_dia = `${getEndpoint('crear_capacidades_por_dia')}`;

  url_update_poligono = `${getEndpoint('update_poligono')}`;
  
  url_obtener_geografia = `${getEndpoint('obtener_geografia')}`;

  url_obtener_capacidades = `${getEndpoint('obtener_capacidades')}`;

  url_eliminar_geografia = `${getEndpoint('eliminar_geografia')}`;
  
  url_eliminar_capacidad = `${getEndpoint('eliminar_capacidad')}`;

  url_obtener_capacidades_poligono = `${getEndpoint('obt_capacidades_poligono')}`;

  url_detalle_ordenes = `${getEndpoint('detalle_ordenes')}`;

  url_cierre_poligono_log = `${getEndpoint('cierre_poligono_log')}`;

  url_obtener_alertas = `${getEndpoint('obtener_alertas')}`;

  url_crear_alerta = `${getEndpoint('crear_alerta')}`;

  url_editar_alerta = `${getEndpoint('editar_alerta')}`;

  url_cambiar_estado_alerta = `${getEndpoint('cambiar_estado_alerta')}`;

  url_capacidades_poligono_mes_actual = `${getEndpoint('url_capacidades_poligono_mes_actual')}`;

  url_detalle_ordenes_mes_actual = `${getEndpoint('url_detalle_ordenes_mes_actual')}`;

  url_detalle_ordenes_fechapicking = `${getEndpoint('detalle_ordenes_fechapicking')}`;

  url_obtener_capacidades_dias = `${getEndpoint('obtener_capacidades_dias')}`;
  
  url_detalle_llenado_departamento_municipio = `${getEndpoint('detalle_llenado_departamento_municipio')}`;

  url_crear_alertas_automaticas = `${getEndpoint('crear_alertas_automaticas')}`;

  api = `${getEndpoint('obtener_historial')}`;



  public objResponse: any = {
    "success": false,
    "message": "",
    "data": [],
    "details": []
  }

  public urlBase = "";

  constructor(
    private _RequestsService: RequestsService,
    private http: HttpClient
  ) { }

  async getDataRem(rem: string, c_emp: string, stage: string) {

    this.objResponse["codigo"] = undefined;

    try {

      this.urlBase = getEndpoint("url_lambda_liberar_pedido");
      let result = await this.http.get(this.urlBase + 'logistica/basicDataRem?c_emp=' + c_emp + '&rem=' + rem)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse["success"] = false;
        this.objResponse["message"] = "Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.";
      } else {

        if (result.success) {

          // Modelo de entregas parciales: la API retorna un arreglo con todos los registros encontrados (uno por entrega).
          // Modelo tradicional: la API retorna un unico objeto.
          const esEntregaParcial = result.entregas_parciales === "S";
          const registrosCrudos: any[] = esEntregaParcial ? (result.data || []) : [result.data];

          const registros = registrosCrudos.map((registro: any) => ({
            "id": registro.ID,
            "nombres": registro.NOMBRES,
            "identificacion": registro.IDENTIFICACION,
            "agencia": registro.AGENCIA,
            "tienda": registro.TIENDA,
            "estado": registro.ESTADO,
            "estado_codigo": registro.ESTADO_CODIGO,
            "periodo": registro.PERIODO,
            "fecha_picking": registro.FECHA_PICKING,
            "fecha_cita_entrega": registro.FECHA_CITA_ENTREGA,
            "destino": registro.DESTINO,
            "num_pedido_sap": registro.NUM_PEDIDO_SAP
          }));

          this.objResponse["entregas_parciales"] = esEntregaParcial;
          this.objResponse["registros"] = registros;
          // Se mantiene "data" como el primer registro por compatibilidad con releaseOrder/liberar_cita_seus,
          // que aun operan sobre una unica orden (agencia/periodo) y no sobre el modelo de entregas parciales.
          this.objResponse["data"] = registros[0];
          this.objResponse["success"] = true;
          this.objResponse["message"] = result.message;
        } else if (result.success === false && result.codigo) {
          // Respuesta de negocio del back (HTTP 200): la OP no se puede gestionar (ej. ya fue entregada).
          // El mensaje viene listo del back y se muestra tal cual.
          this.objResponse["success"] = false;
          this.objResponse["codigo"] = result.codigo;
          this.objResponse["entregas_parciales"] = false;
          this.objResponse["registros"] = [];
          this.objResponse["message"] = result.message;
        } else if (result.status === 406) {
          // 406: el back no encontro la OP.
          this.objResponse["success"] = false;
          this.objResponse["codigo"] = "OP_NO_ENCONTRADA";
          this.objResponse["entregas_parciales"] = false;
          this.objResponse["registros"] = [];
          this.objResponse["message"] = "No encontramos la OP " + rem + ". Revisa el número y vuelve a intentar.";
        } else {
          this.objResponse["success"] = false;
          this.objResponse["entregas_parciales"] = false;
          this.objResponse["registros"] = [];
          this.objResponse["message"] = "Se ha presentado un error al obtener la " +
            "informacion basica de la remision ingresada.<br/><br/>" + ((result["error"] && result["error"].message) || result.message || "");
        }
      }

    } catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Se ha presentado un error en la peticion al servidor.<br/><br/>" + error;
    } finally {
      return this.objResponse;
    }

  }
    
  async releaseOrder(rem: string, c_emp: string, observaciones: string, usuario: string, stage: string, causal:string, descripcion_causal:string, registro: any = null, id_grupo: any = null) {

    try {

      // Si no se recibe un registro puntual (flujo tradicional, sin entregas parciales), se usa el primero cargado.
      const registroBase = registro || this.objResponse["data"];

      this.urlBase = getEndpoint("url_lambda_liberar_pedido");
      let _body: any = {
        "c_emp": c_emp,
        "agencia": registroBase.agencia,
        "tienda": registroBase.tienda,
        "periodo": registroBase.periodo,
        "num_orden": rem,
        "observaciones": observaciones,
        "usuario": usuario,
        "causal" : causal,
        "descripcion_causal" : descripcion_causal
      };

      // Solo se envia cuando la OP es de entregas parciales: identifica el grupo (PROG_ENTREGASAP_ENC.ID) a liberar.
      if (id_grupo != null) {
        _body["id_grupo"] = id_grupo;
      }

      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.post<any>(this.urlBase + 'logistica/releaseOrder', _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse["success"] = false;
        this.objResponse["message"] = "Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.";
      } else {
        this.objResponse["details"] = result.details;
        if (result.success) {
          this.objResponse["success"] = true;
          this.objResponse["message"] = result.message;
        } else {
          this.objResponse["success"] = false;
          this.objResponse["message"] = "Se ha presentado un error al intentar liberar el pedido<br/><br/>" + ((result["error"] && result["error"].message) || result.message || "");
        }
      }

    } catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Se ha presentado un error en la peticion al servidor<br/><br/>" + error;
    } finally {
      return this.objResponse;
    }


  }

  async getConsultaReversion(doc: number) {
    try {
      ;
      var urlToResponse = `revision-ordenes-pedido/JA?doc=${doc}`;
      this.urlBase = getEndpoint('prueba_consultas_desarrollo');

      let objHeader = {
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
      }
      let result = await this.http.get<any>(this.urlBase + urlToResponse, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse["success"] = false;
        this.objResponse["message"] = "Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.";
      } else {
        this.objResponse["details"] = result.details;
        if (result.success) {
          this.objResponse["success"] = true;
          this.objResponse["data"] = result.data;

        } else {
          this.objResponse["success"] = false;
          this.objResponse["message"] = "Se ha presentado un error al intentar liberar el pedido<br/><br/>" + result["error"].message;
        }
      }
    }
    catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Se ha presentado un error en la peticion al servidor.<br/><br/>" + error;
    } finally {
      return this.objResponse;
    }
  }

  async getConsultaHistorialAsignacionOrdenes(doc: number) {
    try {
      ;
      var urlToResponse = `historial-asignación-Ordenes-Pedido/JA?rem=${doc}`;
      this.urlBase = getEndpoint('prueba_consultas_desarrollo');

      let objHeader = {
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
      }
      let result = await this.http.get<any>(this.urlBase + urlToResponse, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse["success"] = false;
        this.objResponse["message"] = "Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.";
      } else {
        this.objResponse["details"] = result.details;
        if (result.success) {
          this.objResponse["success"] = true;
          this.objResponse["data"] = result.data;

        } else {
          this.objResponse["success"] = false;
          this.objResponse["message"] = "Se ha presentado un error al intentar liberar el pedido<br/><br/>" + result["error"].message;
        }
      }
    }
    catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Se ha presentado un error en la peticion al servidor.<br/><br/>" + error;
    } finally {
      return this.objResponse;
    }
  }

  async obtenerAlertas(id_capacidad: number) {
    try {
      let result = await this.http.get<any>(`${this.url_obtener_alertas}${id_capacidad}`)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse["success"] = false;
        this.objResponse["message"] = "Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.";
      } else {
        if (result.status === "success") {
          this.objResponse["success"] = true;
          this.objResponse["data"] = result.data;
          this.objResponse["message"] = "Alertas obtenidas correctamente";
        } else {
          this.objResponse["success"] = false;
          this.objResponse["message"] = "Error al obtener las alertas";
        }
      }
    } catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Se ha presentado un error en la peticion al servidor.<br/><br/>" + error;
    } finally {
      return this.objResponse;
    }
  }

  async cambiarEstadoAlerta(ID_ALERT: string, estado: string, usuario_modificacion: string) {
    try {
      let _body = {
        "ID_ALERT": ID_ALERT,
        "ESTADO": estado,
        "USUARIO_MODIFICACION": usuario_modificacion
      };

      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      let result = await this.http.post<any>(`${this.url_cambiar_estado_alerta}`, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse["success"] = false;
        this.objResponse["message"] = "Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.";
      } else {
        if (result.status === "success") {
          this.objResponse["success"] = true;
          this.objResponse["message"] = result.message;
        } else {
          this.objResponse["success"] = false;
          this.objResponse["message"] = "Error al cambiar el estado de la alerta";
        }
      }
    } catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Se ha presentado un error en la peticion al servidor.<br/><br/>" + error;
    } finally {
      return this.objResponse;
    }
  }

  async getConsultaHistorialComprometidasOrdenes(doc: number) {
    try {
      ;
      var urlToResponse = `Consulta-Historial-comprometida-orden-compra-Ordenes-Pedido/JA?desp=${doc}`;
      this.urlBase = getEndpoint('prueba_consultas_desarrollo');

      let objHeader = {
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
      }
      let result = await this.http.get<any>(this.urlBase + urlToResponse, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse["success"] = false;
        this.objResponse["message"] = "Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.";
      } else {
        this.objResponse["details"] = result.details;
        if (result.success) {
          this.objResponse["success"] = true;
          this.objResponse["data"] = result.data;

        } else {
          this.objResponse["success"] = false;
          this.objResponse["message"] = "Se ha presentado un error al intentar liberar el pedido<br/><br/>" + result["error"].message;
        }
      }
    }
    catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Se ha presentado un error en la peticion al servidor.<br/><br/>" + error;
    } finally {
      return this.objResponse;
    }
  }
  
  
  /**
   * Libera la cita en SEUS. Se llama solo despues de que releaseOrder salio bien, con el registro elegido,
   * y devuelve el resultado de esta llamada (no el estado compartido de otras).
   */
  async liberar_cita_seus(rem: string, c_emp: string, registro: any = null) {

    const registroBase = registro || this.objResponse["data"];
    const respuesta = { success: false, message: "" };

    try {

      this.urlBase = getEndpoint("liberarCita_seus");
      let _body = {
        "pe_vcEmpresa": c_emp,
        "pe_vcAgeOp": registroBase.agencia,
        "pe_vcPerOp": registroBase.periodo,
        "pe_vcNumOp": rem,
      };

      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.post<any>(this.urlBase + '/liberar_cita/JA', _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result && result.name == "TimeoutError") {
        respuesta.message = "Se agoto el tiempo de espera al confirmar la cita.";
      } else if (result instanceof HttpErrorResponse) {
        respuesta.message = "No se pudo confirmar la cita (puede que la OP no tenga fecha de compromiso asignada).";
      } else if (result && result.success === false) {
        respuesta.message = result.message || "No se pudo confirmar la cita.";
      } else {
        respuesta.success = true;
      }

    } catch (error) {
      respuesta.message = "Error al confirmar la cita: " + error;
    }

    return respuesta;

  }

  async crear_poligono(cod_poligono: string, nom_poligono: string, usuario_cre: string) {
    try {
      let _body = {
        "cod_poligono": cod_poligono,
        "nom_poligono": nom_poligono,
        "usuario_cre": usuario_cre
      };

      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.post<any>(this.url_crear_poligono, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });
      
      // Adaptar según la estructura de la respuesta real
      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        // Éxito: la API retorna data
        this.objResponse = {
          success: true,
          message: "Polígonos creado correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        // Falla: podrías tener un mensaje de error en result.message
        this.objResponse = {
          success: false,
          message: result.error.detail || "Se ha presentado un error al intentar obtener el polígono.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async obtener_poligono() {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.get<any>(this.url_poligonos, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });
  
      // Adaptar según la estructura de la respuesta real
      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        // Éxito: la API retorna data
        this.objResponse = {
          success: true,
          message: "Polígonos obtenidos correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        // Falla: podrías tener un mensaje de error en result.message
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener el polígono.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async obtener_departamento() {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.get<any>(this.url_get_departamento+this.company, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });
  
      // Adaptar según la estructura de la respuesta real
      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        // Éxito: la API retorna data
        this.objResponse = {
          success: true,
          message: "Departamento obtenidos correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        // Falla: podrías tener un mensaje de error en result.message
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener el polígono.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async obtener_municipio() {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.get<any>(this.url_get_municipio+this.company, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });
  
      // Adaptar según la estructura de la respuesta real
      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        // Éxito: la API retorna data
        this.objResponse = {
          success: true,
          message: "Municipios obtenidos correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        // Falla: podrías tener un mensaje de error en result.message
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener el polígono.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }
  
  async obtener_zona() {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.get<any>(this.url_zonas+this.company, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });
  
      // Adaptar según la estructura de la respuesta real
      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        // Éxito: la API retorna data
        this.objResponse = {
          success: true,
          message: "Zonas obtenidos correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        // Falla: podrías tener un mensaje de error en result.message
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener el polígono.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async crear_geografia(data: any) {
    try {
      
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.post<any>(this.url_crear_geografia, data, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      // Adaptar según la estructura de la respuesta real
      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.success) {
        // Éxito: la API retorna data
        this.objResponse = {
          success: true,
          message: "Geografia creado correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        // Falla: podrías tener un mensaje de error en result.message
        this.objResponse = {
          success: false,
          message: result.error.detail || "Se ha presentado un error al intentar obtener geografia.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async crear_capacidades(ID_POLI: any, COD_BODEGA: any, CIERRE_AUTOMATICO: any, PORCENTAJE_CIERRE: any, CUBICAJE_TOTAL: any,CANTIDAD_ORD_TOTAL: any,USUARIO_CREACION: any) {
    try {
      PORCENTAJE_CIERRE = CIERRE_AUTOMATICO == 'N' ? 100 : PORCENTAJE_CIERRE; 
      let _body = {
        "ID_POLI": ID_POLI,
        "COD_BODEGA": COD_BODEGA,
        "CIERRE_AUTOMATICO": CIERRE_AUTOMATICO,
        "PORCENTAJE_CIERRE": PORCENTAJE_CIERRE,
        "CUBICAJE_TOTAL": CUBICAJE_TOTAL,
        "CANTIDAD_ORD_TOTAL": CANTIDAD_ORD_TOTAL,
        "USUARIO_CREACION": USUARIO_CREACION
      };
      
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.post<any>(this.url_crear_capacidades, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      // Adaptar según la estructura de la respuesta real
      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: result.success,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          id_reg: [],
          details: undefined
        };
      } else if (result.success) {
        // Éxito: la API retorna data
        this.objResponse = {
          success: result.success,
          message: "Geografia creado correctamente.",
          id_reg: result.id_reg,
          details: undefined
        };
      } else {
        // Falla: podrías tener un mensaje de error en result.message
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener geografia.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async crear_capacidades_por_dia(ID_POLI: any, COD_BODEGA: any, CIERRE_AUTOMATICO: any, PORCENTAJE_CIERRE: any, CUBICAJE_TOTAL: any, CANTIDAD_ORD_TOTAL: any, FECHAS: Date[], USUARIO_CREACION: any) {
    try {
      
      PORCENTAJE_CIERRE = CIERRE_AUTOMATICO == 'N' ? 100 : PORCENTAJE_CIERRE;
      
      // Crear un array de registros, uno por cada fecha
      const registros = FECHAS.map(fecha => {
        const year = fecha.getFullYear();
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const day = String(fecha.getDate()).padStart(2, '0');
        const fechaFormateada = `${year}-${month}-${day}`;
        
        return {
          "ID_POLI": Number(ID_POLI),
          "COD_BODEGA": COD_BODEGA,
          "CIERRE_AUTOMATICO": CIERRE_AUTOMATICO,
          "PORCENTAJE_CIERRE": Number(PORCENTAJE_CIERRE) || 0,
          "CUBICAJE_TOTAL": Number(CUBICAJE_TOTAL) || 0,
          "CANTIDAD_ORD_TOTAL": Number(CANTIDAD_ORD_TOTAL) || 0,
          "FECHA_DIA": fechaFormateada,
          "USUARIO_CREACION": USUARIO_CREACION
        };
      });
      
      console.log('Registros a enviar:', registros);
      
      let _body = {
        "registros": registros
      };
      
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.post<any>(this.url_crear_capacidades_por_dia, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: result.success,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          id_reg_cal: [],
          details: undefined
        };
      } else if (result.success) {
        this.objResponse = {
          success: result.success,
          message: `Capacidades por día creadas correctamente. Se crearon ${registros.length} registros.`,
          data: result.data,
          id_reg_cal: result.id_reg_cal,
          details: undefined
        };
      } else {
        this.objResponse = {
          success: result.success,
          message: result.message || "Se ha presentado un error al intentar crear las capacidades por día.",
          data: [],
          id_reg_cal: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        id_reg_cal: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async update_poligono(id_poli: number, nom_poligono: string, estado_legible: string, usuario: string) {
    try {
      let _body = {
        "id_poli": id_poli,
        "nom_poligono": nom_poligono,
        "estado_legible": estado_legible,
        "usuario": usuario
      };

      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.put<any>(this.url_update_poligono, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse["success"] = false;
        this.objResponse["message"] = "Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.";
      } else {
        this.objResponse["details"] = result.details;
        if (result.status) {
          this.objResponse["success"] = true;
          this.objResponse["message"] = result.message;
        } else {
          this.objResponse["success"] = false;
          this.objResponse["message"] = "Se ha presentado un error al intentar actualizar el polígono<br/><br/>" + result["error"].message;
        }
      }

    } catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Se ha presentado un error en la peticion al servidor<br/><br/>" + error;
    } finally {
      return this.objResponse;
    }
  }

  async obtener_geografia(id_poli: any) {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.get<any>(this.url_obtener_geografia + '/' + id_poli, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });
  
      // Adaptar según la estructura de la respuesta real
      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        // Éxito: la API retorna data
        this.objResponse = {
          success: true,
          message: "Geografia obtenidos correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        // Falla: podrías tener un mensaje de error en result.message
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener el polígono.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async obtener_capacidades(id_poli: any) {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.get<any>(this.url_obtener_capacidades + '/' + id_poli, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });
  
      // Adaptar según la estructura de la respuesta real
      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        // Éxito: la API retorna data
        this.objResponse = {
          success: true,
          message: "Capacidades obtenidos correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        // Falla: podrías tener un mensaje de error en result.message
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener las capacidades.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async eliminar_geografia(tipo: string, codigo: string, id_poli: string) {
    try {
      const data = {
        tipo: tipo,
        codigo: codigo,
        id_poli: id_poli
      };
      
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.delete<any>(this.url_eliminar_geografia, { ...objHeader, body: data })
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: result.message || "Geografía eliminada correctamente.",
          data: [],
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.detail || "Se ha presentado un error al intentar eliminar la geografía.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async eliminarCapacidad(id: number) {
    try {
      const data = {
        id_reg: id
      };
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.delete<any>(this.url_eliminar_capacidad, { ...objHeader, body: data })
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: result.message || "Capacidad eliminada correctamente.",
          data: [],
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.detail || "Se ha presentado un error al intentar eliminar la capacidad.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Se ha presentado un error en la petición al servidor.<br/><br/>" + error;
    } finally {
      return this.objResponse;
    }
  }

  async obtener_capacidades_poligono(empresa: string, fecha_picking: string, codigo_bodega: string) {
    try {
      let _body = {
        "empresa": empresa,
        "fecha_picking": fecha_picking,
        "codigo_bodega": codigo_bodega
      };

      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.post<any>(this.url_obtener_capacidades_poligono, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success" && result.data.length > 0) {
        this.objResponse = {
          success: true,
          message: "Capacidades por polígono obtenidas correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener las capacidades por polígono.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  /**
   * Obtiene el detalle de órdenes para un polígono específico
   * @param id_poligono - ID del polígono
   * @param codigo_bodega - Código de la bodega
   * @param empresa - Código de la empresa (ej: 'JA')
   * @param fechaFormateada - Fecha en formato YYYY-MM-DD
   * @returns Promise con los detalles de las órdenes
   */
  async detalle_ordenes(id_poligono: string, codigo_bodega: string, empresa: string, fechaFormateada: string) {
    try {
      const _body = {
        "id_poligono": id_poligono,
        "codigo_bodega": codigo_bodega,
        "empresa": empresa,
        "fecha_picking": fechaFormateada
      };

      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.post<any>(this.url_detalle_ordenes, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: result.message || "Detalles de órdenes obtenidos correctamente.",
          data: result.data || [],
          details: {
            totalRegistros: result.data?.length || 0,
            fechaConsulta: fechaFormateada,
            poligono: id_poligono,
            bodega: codigo_bodega
          }
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || result.detail || "Se ha presentado un error al intentar obtener los detalles de órdenes.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async cierre_poligono_log(pe_vcEmp: string, pe_nuIdPoligono: string, pe_vcCodBodega: string,pe_dtFechaPicking:string,pe_vcUsuario:string,pe_vcOrigen:string) {
    try {
      let _body = {
        "pe_vcEmp": pe_vcEmp,
        "pe_nuIdPoligono": pe_nuIdPoligono,
        "pe_vcCodBodega": pe_vcCodBodega,
        "pe_dtFechaPicking":pe_dtFechaPicking,
        "pe_vcUsuario":pe_vcUsuario,
        "pe_vcOrigen":pe_vcOrigen
      }

      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.post<any>(this.url_cierre_poligono_log, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: "se realizo cierre poligono.",
          data: [],
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar cerrar el poligono.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async crearAlerta(alertaData: any) {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      let result = await this.http.post<any>(this.url_crear_alerta, alertaData, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse["success"] = false;
        this.objResponse["message"] = "Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.";
      } else {
        if (result.status === "success") {
          this.objResponse["success"] = true;
          this.objResponse["message"] = result.message;
        } else {
          this.objResponse["success"] = false;
          this.objResponse["message"] = "Error al crear alerta: " + result.message;
        }
      }
    } catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Error en la petición al servidor: " + error;
    } finally {
      return this.objResponse;
    }
  }

  async editarAlerta(alertaData: any) {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      let result = await this.http.put<any>(this.url_editar_alerta, alertaData, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse["success"] = false;
        this.objResponse["message"] = "Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.";
      } else {
        if (result.status === "success") {
          this.objResponse["success"] = true;
          this.objResponse["message"] = result.message;
        } else {
          this.objResponse["success"] = false;
          this.objResponse["message"] = "Error al editar alerta: " + result.message;
        }
      }
    } catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Error en la petición al servidor: " + error;
    } finally {
      return this.objResponse;
    }
  }

  async obtener_capacidades_poligono_mes_actual(empresa: string, codigo_bodega: string) {
    try {
      let _body = {
        "empresa": empresa,
        "codigo_bodega": codigo_bodega
      };

      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.post<any>(this.url_capacidades_poligono_mes_actual, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: "Capacidades del mes actual obtenidas correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener las capacidades del mes actual.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  /**
   * Obtiene el detalle de órdenes del mes actual para una bodega
   * @param empresa - Código de la empresa (ej: 'JA')
   * @param codigo_bodega - Código de la bodega
   * @returns Promise con los detalles de las órdenes del mes actual
   */
  async detalle_ordenes_mes_actual(empresa: string, codigo_bodega: string) {
    try {
      const _body = {
        "empresa": empresa,
        "codigo_bodega": codigo_bodega
      };

      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.post<any>(this.url_detalle_ordenes_mes_actual, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: result.message || "Detalle de órdenes del mes actual obtenido correctamente.",
          data: result.data || [],
          details: {
            totalRegistros: result.data?.length || 0,
            bodega: codigo_bodega,
            tipoConsulta: 'mes_actual'
          }
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || result.detail || "Se ha presentado un error al intentar obtener el detalle de órdenes del mes actual.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  /**
   * Obtiene el detalle de órdenes por fecha de picking para una bodega
   * @param codigo_bodega - Código de la bodega
   * @param empresa - Código de la empresa (ej: 'JA')
   * @param fechaFormateada - Fecha en formato YYYY-MM-DD
   * @returns Promise con los detalles de las órdenes por fecha
   */
  async detalle_ordenesFechaPicking(codigo_bodega: string, empresa: string, fechaFormateada: string) {
    try {
      const _body = {
        "codigo_bodega": codigo_bodega,
        "empresa": empresa,
        "fecha_picking": fechaFormateada
      };

      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.post<any>(this.url_detalle_ordenes_fechapicking, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: result.message || "Detalles de órdenes por fecha obtenidos correctamente.",
          data: result.data || [],
          details: {
            totalRegistros: result.data?.length || 0,
            fechaConsulta: fechaFormateada,
            bodega: codigo_bodega,
            tipoConsulta: 'fecha_picking'
          }
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || result.detail || "Se ha presentado un error al intentar obtener los detalles de órdenes por fecha.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async obtener_capacidades_dias(id_poli: any, cod_bodega?: string) {
    try {
      let url = `${this.url_obtener_capacidades_dias}/${id_poli}`;
      if (cod_bodega) {
        url += `?cod_bodega=${cod_bodega}`;
      }
      
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.get<any>(url, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });
  
      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: "Capacidades por días obtenidas correctamente.",
          data: result.data,
          details: undefined
        };
      } else if (
        result.status === 404 ||
        (result.detail && /no se encontraron datos/i.test(result.detail)) ||
        (result.error?.detail && /no se encontraron datos/i.test(result.error.detail))
      ) {
        // El API responde 404 cuando la bodega/polígono no tiene capacidades por día — es un resultado vacío válido, no un error
        this.objResponse = {
          success: true,
          message: "No hay capacidades por día registradas para esta bodega.",
          data: [],
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.error?.detail || result.detail || result.message || "Se ha presentado un error al intentar obtener las capacidades por días.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async detalle_llenado_departamento_municipio(empresa: string, codigo_bodega: string, fecha_picking: string, id_poligono: string) {
    try {
      let _body = {
        "empresa": empresa,
        "codigo_bodega": codigo_bodega,
        "fecha_picking": fecha_picking,
        "id_poligono": id_poligono
      };

      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.post<any>(this.url_detalle_llenado_departamento_municipio, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: "Detalle de llenado por departamento y municipio obtenido correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener el detalle de llenado.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async crearAlertasAutomaticas(idRegCapac: string, usuarioCreacion: string) {
    try {
      let _body = {
        "ID_REG_CAPAC": idRegCapac,
        "USUARIO_CREACION": usuarioCreacion
      };

      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      let result = await this.http.post<any>(`${this.url_crear_alertas_automaticas}${idRegCapac}`, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse["success"] = false;
        this.objResponse["message"] = "Se ha agotado el tiempo de espera para la peticion realizada.<br/>Reintentar nuevamente dentro de unos segundos.";
      } else {
        if (result.status === 'success') {
          this.objResponse["success"] = true;
          this.objResponse["message"] = result.message;
        } else {
          this.objResponse["success"] = false;
          this.objResponse["message"] = "Se ha presentado un error al crear las alertas automáticas<br/><br/>" + (result.detail || result.message || 'Error desconocido');
        }
      }
    } catch (error) {
      this.objResponse["success"] = false;
      this.objResponse["message"] = "Se ha presentado un error en la peticion al servidor<br/><br/>" + error;
    } finally {
      return this.objResponse;
    }
  }

  async obtenerPoligonos() {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      let result = await this.http.get<any>(this.url_poligonos, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: "Polígonos obtenidos correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener los polígonos.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async obtenerHistorialPoligono(idPoligono: number) {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      let result = await this.http.get<any>(`${this.api}/${this.company}/historial_cierre_apertura_poligono/${idPoligono}`, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: "Histórico obtenido correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener el histórico.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async obtenerHistorialMovimientos(idPoligono: number) {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      let result = await this.http.get<any>(`${this.api}/${this.company}/gethistorialmonitoreo_detalle/${idPoligono}`, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: "Movimientos obtenidos correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || result.detail || "Se ha presentado un error al intentar obtener los movimientos.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async obtenerHistorialGeografia(idPoligono: number) {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      let result = await this.http.get<any>(`${this.api}/${this.company}/gethistorialgeografia/${idPoligono}`, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: "Histórico de geografía obtenido correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener el histórico de geografía.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async obtenerHistorialCapacidades(idPoligono: number) {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      let result = await this.http.get<any>(`${this.api}/${this.company}/gethistorialcapacidades/${idPoligono}`, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: "Histórico de capacidades obtenido correctamente.",
          data: result.data,
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar obtener el histórico de capacidades.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

  async obtenerHistorialAlertas(idCapacidad: number) {
    try {
      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      let result = await this.http.get<any>(`${this.api}/${this.company}/gethistorialalertas/${idCapacidad}`, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        return {
          status: 'error',
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: []
        };
      } else if (result.status === "success") {
        return result;
      } else {
        return {
          status: 'error',
          message: result.message || "Se ha presentado un error al intentar obtener el histórico de alertas.",
          data: []
        };
      }
    } catch (error) {
      return {
        status: 'error',
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: []
      };
    }
  }

  async asignar_poligono_ops(empresa: string, id_poligono: number, usuario: string, ordenes: { num_orden: string }[]) {
    try {
      const _body = { empresa, id_poligono, usuario, ordenes };
      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.put<any>(getEndpoint('asignar_poligono_ops'), _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp; })
        .catch((err) => { return err; });

      if (result.hasOwnProperty('name') && result.name === 'TimeoutError') {
        this.objResponse = { success: false, message: 'Se ha agotado el tiempo de espera para la petición realizada.', data: [], details: undefined };
      } else if (result.status === 'success') {
        this.objResponse = { success: true, message: result.message || 'Polígono asignado correctamente.', data: result.data || [], details: undefined };
      } else {
        this.objResponse = { success: false, message: result.message || result.detail || 'Error al asignar el polígono.', data: [], details: undefined };
      }
    } catch (error) {
      this.objResponse = { success: false, message: 'Se ha presentado un error en la petición al servidor.<br/><br/>' + error, data: [], details: undefined };
    } finally {
      return this.objResponse;
    }
  }

  async detalle_ordenes_sin_poligono(empresa: string, codigo_bodega: string, fecha_inicio: string, fecha_fin: string) {
    try {
      const _body = { empresa, codigo_bodega, fecha_inicio, fecha_fin };
      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.post<any>(getEndpoint('detalle_ordenes_sin_poligono'), _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp; })
        .catch((err) => { return err; });

      if (result.hasOwnProperty('name') && result.name === 'TimeoutError') {
        this.objResponse = { success: false, message: 'Se ha agotado el tiempo de espera para la petición realizada.', data: [], details: undefined };
      } else if (result.status === 'success') {
        this.objResponse = { success: true, message: 'OPs sin polígono obtenidas correctamente.', data: result.data, details: undefined };
      } else {
        this.objResponse = { success: false, message: result.message || 'Error al obtener las OPs sin polígono.', data: [], details: undefined };
      }
    } catch (error) {
      this.objResponse = { success: false, message: 'Se ha presentado un error en la petición al servidor.<br/><br/>' + error, data: [], details: undefined };
    } finally {
      return this.objResponse;
    }
  }

  async ops_por_poligono(empresa: string, id_poligono: string, codigo_bodega: string, fecha_inicio: string, fecha_fin: string) {
    try {
      const _body = { empresa, id_poligono, codigo_bodega, fecha_inicio, fecha_fin };
      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.post<any>(getEndpoint('ops_por_poligono'), _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp; })
        .catch((err) => { return err; });

      if (result.hasOwnProperty('name') && result.name === 'TimeoutError') {
        this.objResponse = { success: false, message: 'Se ha agotado el tiempo de espera para la petición realizada.', data: [], details: undefined };
      } else if (result.status === 'success') {
        this.objResponse = { success: true, message: 'OPs obtenidas correctamente.', data: result.data, details: undefined };
      } else {
        this.objResponse = { success: false, message: result.message || result.detail || 'Error al obtener las OPs por polígono.', data: [], details: undefined };
      }
    } catch (error) {
      this.objResponse = { success: false, message: 'Se ha presentado un error en la petición al servidor.<br/><br/>' + error, data: [], details: undefined };
    } finally {
      return this.objResponse;
    }
  }

  async update_capacidades(ID_REG: string, COD_BODEGA: string, CIERRE_AUTOMATICO: string, PORCENTAJE_CIERRE: number, CUBICAJE_TOTAL: number, CANTIDAD_ORD_TOTAL: number, USUARIO_MODIFICACION: string) {
    try {
      const _body = { ID_REG, COD_BODEGA, CIERRE_AUTOMATICO, PORCENTAJE_CIERRE, CUBICAJE_TOTAL, CANTIDAD_ORD_TOTAL, USUARIO_MODIFICACION };
      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.put<any>(getEndpoint('update_capacidades'), _body, objHeader)
        .pipe(timeout(29000)).toPromise().then(r => r).catch(e => e);

      if (result?.name === 'TimeoutError') {
        this.objResponse = { success: false, message: 'Se ha agotado el tiempo de espera.', data: [], details: undefined };
      } else if (result.status === 'success' || result.success) {
        this.objResponse = { success: true, message: result.message || 'Capacidad actualizada correctamente.', data: result.data || [], details: undefined };
      } else {
        this.objResponse = { success: false, message: result.message || result.detail || 'Error al actualizar la capacidad.', data: [], details: undefined };
      }
    } catch (error) {
      this.objResponse = { success: false, message: 'Error en la petición al servidor.<br/><br/>' + error, data: [], details: undefined };
    } finally {
      return this.objResponse;
    }
  }

  async update_capacidades_por_dia(ID_REG_CAL: string, COD_BODEGA: string, CIERRE_AUTOMATICO: string, PORCENTAJE_CIERRE: number, CUBICAJE_TOTAL: number, CANTIDAD_ORD_TOTAL: number, FECHA_DIA: string, USUARIO_MODIFICACION: string) {
    try {
      const _body = { ID_REG_CAL, COD_BODEGA, CIERRE_AUTOMATICO, PORCENTAJE_CIERRE, CUBICAJE_TOTAL, CANTIDAD_ORD_TOTAL, FECHA_DIA, USUARIO_MODIFICACION };
      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.put<any>(getEndpoint('update_capacidades_por_dia'), _body, objHeader)
        .pipe(timeout(29000)).toPromise().then(r => r).catch(e => e);

      if (result?.name === 'TimeoutError') {
        this.objResponse = { success: false, message: 'Se ha agotado el tiempo de espera.', data: [], details: undefined };
      } else if (result.status === 'success' || result.success) {
        this.objResponse = { success: true, message: result.message || 'Capacidad por día actualizada correctamente.', data: result.data || [], details: undefined };
      } else {
        this.objResponse = { success: false, message: result.message || result.detail || 'Error al actualizar la capacidad por día.', data: [], details: undefined };
      }
    } catch (error) {
      this.objResponse = { success: false, message: 'Error en la petición al servidor.<br/><br/>' + error, data: [], details: undefined };
    } finally {
      return this.objResponse;
    }
  }

  async eliminar_capacidad_por_dia(ID_REG_CAL: string) {
    try {
      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.delete<any>(getEndpoint('eliminar_capacidad_por_dia'), { ...objHeader, body: { ID_REG_CAL } })
        .pipe(timeout(29000)).toPromise().then(r => r).catch(e => e);

      if (result?.name === 'TimeoutError') {
        this.objResponse = { success: false, message: 'Se ha agotado el tiempo de espera.', data: [], details: undefined };
      } else if (result.status === 'success' || result.success) {
        this.objResponse = { success: true, message: result.message || 'Capacidad por día eliminada correctamente.', data: [], details: undefined };
      } else {
        this.objResponse = { success: false, message: result.message || result.detail || 'Error al eliminar la capacidad por día.', data: [], details: undefined };
      }
    } catch (error) {
      this.objResponse = { success: false, message: 'Error en la petición al servidor.<br/><br/>' + error, data: [], details: undefined };
    } finally {
      return this.objResponse;
    }
  }

  async cerrar_servicios_poligono(empresa: string, id_poligono: string, codigo_bodega: string, fecha_picking: string, usuario: string, accion: 'CERRAR' | 'ABRIR') {
    try {
      const _body = { empresa, id_poligono, codigo_bodega, fecha_picking, usuario, accion };
      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.post<any>(getEndpoint('cerrar_servicios_poligono'), _body, objHeader)
        .pipe(timeout(29000)).toPromise().then(r => r).catch(e => e);

      if (result?.name === 'TimeoutError') {
        this.objResponse = { success: false, message: 'Se ha agotado el tiempo de espera para la petición realizada.', data: null, details: undefined };
      } else if (result.status === 'success' || result.status === 'sin_cambios') {
        this.objResponse = { success: true, message: result.message || 'Operación realizada correctamente.', data: result, details: undefined };
      } else {
        this.objResponse = { success: false, message: result.message || result.detail || 'Error al gestionar los servicios.', data: null, details: undefined };
      }
    } catch (error) {
      this.objResponse = { success: false, message: 'Se ha presentado un error en la petición al servidor.<br/><br/>' + error, data: null, details: undefined };
    } finally {
      return this.objResponse;
    }
  }

  async consultar_estado_servicios(empresa: string, id_poligono: string, codigo_bodega: string, fecha_picking: string) {
    try {
      const url = `${getEndpoint('estado_servicios_poligono')}${empresa}/${id_poligono}/${codigo_bodega}/estado_servicios/${fecha_picking}`;
      const result = await this.http.get<any>(url)
        .pipe(timeout(29000)).toPromise().then(r => r).catch(e => e);

      if (result?.name === 'TimeoutError') {
        this.objResponse = { success: false, message: 'Se ha agotado el tiempo de espera para la petición realizada.', data: null, details: undefined };
      } else if (result?.status === 'success') {
        this.objResponse = { success: true, message: '', data: result.data, details: undefined };
      } else {
        this.objResponse = { success: false, message: result?.message || 'Error al consultar el estado de servicios.', data: null, details: undefined };
      }
    } catch (error) {
      this.objResponse = { success: false, message: 'Se ha presentado un error en la petición al servidor.<br/><br/>' + error, data: null, details: undefined };
    } finally {
      return this.objResponse;
    }
  }

  async consultar_servicios_dia_picking(empresa: string, codigo_bodega: string, fecha_picking: string) {
    try {
      const url = `${this.api}/${empresa}/${codigo_bodega}/servicios_dia_picking/${fecha_picking}`;
      const result = await this.http.get<any>(url)
        .pipe(timeout(29000)).toPromise().then(r => r).catch(e => e);

      if (result?.name === 'TimeoutError') {
        this.objResponse = { success: false, message: 'Se ha agotado el tiempo de espera para la petición realizada.', data: null, details: undefined };
      } else if (result?.status === 'success') {
        this.objResponse = { success: true, message: '', data: result.data, details: undefined };
      } else {
        this.objResponse = { success: false, message: result?.message || result?.detail || 'Error al consultar los servicios del día de picking.', data: null, details: undefined };
      }
    } catch (error) {
      this.objResponse = { success: false, message: 'Se ha presentado un error en la petición al servidor.<br/><br/>' + error, data: null, details: undefined };
    } finally {
      return this.objResponse;
    }
  }

  async cierre_masivo_servicios_dia(empresa: string, codigo_bodega: string, fecha_picking: string, usuario: string) {
    try {
      const _body = { empresa, codigo_bodega, fecha_picking, usuario };
      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.post<any>(`${this.api}/cierre_masivo_servicios_dia`, _body, objHeader)
        .pipe(timeout(29000)).toPromise().then(r => r).catch(e => e);

      if (result?.name === 'TimeoutError') {
        this.objResponse = { success: false, message: 'Se ha agotado el tiempo de espera para la petición realizada.', data: null, details: undefined };
      } else if (result?.status === 'success' || result?.status === 'sin_cambios') {
        this.objResponse = { success: true, message: result.message || 'Cierre masivo de servicios ejecutado correctamente.', data: result, details: undefined };
      } else {
        this.objResponse = { success: false, message: result?.message || result?.detail || 'Error al ejecutar el cierre masivo de servicios.', data: null, details: undefined };
      }
    } catch (error) {
      this.objResponse = { success: false, message: 'Se ha presentado un error en la petición al servidor.<br/><br/>' + error, data: null, details: undefined };
    } finally {
      return this.objResponse;
    }
  }

  async apertura_masiva_servicios_dia(empresa: string, codigo_bodega: string, fecha_picking: string, usuario: string) {
    try {
      const _body = { empresa, codigo_bodega, fecha_picking, usuario };
      const objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const result = await this.http.post<any>(`${this.api}/apertura_masiva_servicios_dia`, _body, objHeader)
        .pipe(timeout(29000)).toPromise().then(r => r).catch(e => e);

      if (result?.name === 'TimeoutError') {
        this.objResponse = { success: false, message: 'Se ha agotado el tiempo de espera para la petición realizada.', data: null, details: undefined };
      } else if (result?.status === 'success' || result?.status === 'sin_cambios') {
        this.objResponse = { success: true, message: result.message || 'Apertura masiva de servicios ejecutada correctamente.', data: result, details: undefined };
      } else {
        this.objResponse = { success: false, message: result?.message || result?.detail || 'Error al ejecutar la apertura masiva de servicios.', data: null, details: undefined };
      }
    } catch (error) {
      this.objResponse = { success: false, message: 'Se ha presentado un error en la petición al servidor.<br/><br/>' + error, data: null, details: undefined };
    } finally {
      return this.objResponse;
    }
  }

  async apertura_poligono_log(pe_vcEmp: string, pe_nuIdPoligono: string, pe_vcCodBodega: string,pe_dtFechaPicking:string,pe_vcUsuario:string,pe_vcOrigen:string) {
    try {
      let _body = {
        "pe_vcEmp": pe_vcEmp,
        "pe_nuIdPoligono": pe_nuIdPoligono,
        "pe_vcCodBodega": pe_vcCodBodega,
        "pe_dtFechaPicking":pe_dtFechaPicking,
        "pe_vcUsuario":pe_vcUsuario,
        "pe_vcOrigen":pe_vcOrigen
      }

      let objHeader = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      let result = await this.http.post<any>(`${this.api}/apertura_poligono_log`, _body, objHeader)
        .pipe(timeout(29000))
        .toPromise()
        .then((resp) => { return resp })
        .catch((err) => { return err });

      if (result.hasOwnProperty('name') && result.name == "TimeoutError") {
        this.objResponse = {
          success: false,
          message: "Se ha agotado el tiempo de espera para la petición realizada.<br/>Reintentar nuevamente dentro de unos segundos.",
          data: [],
          details: undefined
        };
      } else if (result.status === "success") {
        this.objResponse = {
          success: true,
          message: "se realizo apertura de poligono.",
          data: [],
          details: undefined
        };
      } else {
        this.objResponse = {
          success: false,
          message: result.message || "Se ha presentado un error al intentar abrir el poligono.",
          data: [],
          details: undefined
        };
      }
    } catch (error) {
      this.objResponse = {
        success: false,
        message: "Se ha presentado un error en la petición al servidor<br/><br/>" + error,
        data: [],
        details: undefined
      };
    } finally {
      return this.objResponse;
    }
  }

}


 

